import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NotificationListComponent } from './pages/notification-list/notification-list.component'
import { NotificationsRoutingModule } from './notifications-routing.module'
import { NotificationsDropdownComponent } from './components/notifications-dropdown/notifications-dropdown.component'
import { SharedModule } from 'src/app/shared/shared.module'
import { NotificationCardComponent } from './components/notification-card/notification-card.component'

@NgModule({
	declarations: [NotificationListComponent, NotificationsDropdownComponent, NotificationCardComponent],
	imports: [CommonModule, NotificationsRoutingModule, SharedModule],
	exports: [NotificationsDropdownComponent, NotificationListComponent],
})
export class NotificationsModule {}
